<template>
  <div>
    <!-- Action Buttons (Fixed FAB or Inline) -->
    <div v-if="!readonly && !fixed" class="d-flex align-center">
      <v-chip
        v-if="isDirty"
        small
        color="warning"
        text-color="white"
        class="mr-3"
      >
        <v-icon left small>mdi-pencil</v-icon>
        Neuložené zmeny
      </v-chip>
      <v-btn
        color="primary"
        :loading="loading"
        @click="$emit('save')"
      >
        <v-icon left>mdi-content-save</v-icon>
        {{ saveText }}
      </v-btn>
    </div>

    <v-btn
      v-if="!readonly && fixed"
      class="ma-2"
      fixed
      right
      bottom
      dark
      fab
      large
      :color="isDirty ? 'warning' : 'primary'"
      :loading="loading"
      @click="$emit('save')"
    >
      <v-icon>{{ isDirty ? 'mdi-content-save-alert' : 'mdi-content-save' }}</v-icon>
    </v-btn>

    <!-- Snackbar Notifications -->
    <v-snackbar
      v-model="savedSnackbar"
      color="success"
      :timeout="3000"
      top
      right
    >
      <v-icon left>
        mdi-check-circle
      </v-icon>
      {{ successMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="savedSnackbar = false"
        >
          Zavrieť
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar
      v-model="errorSnackbar"
      color="error"
      :timeout="5000"
      top
      right
    >
      <v-icon left>
        mdi-alert-circle
      </v-icon>
      {{ errorMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="errorSnackbar = false"
        >
          Zavrieť
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'FormActions',
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isDirty: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: true,
    },
    saveText: {
      type: String,
      default: 'Uložiť',
    },
    successMessage: {
      type: String,
      default: 'Úspešne uložené',
    },
    errorMessage: {
      type: String,
      default: 'Nastala chyba pri ukladaní',
    },
  },
  data() {
    return {
      savedSnackbar: false,
      errorSnackbar: false,
    };
  },
  methods: {
    showSuccess() {
      this.savedSnackbar = true;
    },
    showError() {
      this.errorSnackbar = true;
    },
  },
};
</script>
